export const offset = function offset (el) {
  let rect = el.getBoundingClientRect()
  let scrollLeft = window.scrollX || document.documentElement.scrollLeft
  let scrollTop = window.scrollY || document.documentElement.scrollTop

  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
